module.exports = __webpack_public_path__ + "static/media/forward.62475a5c.svg";